import { addNotification } from '../notifications/notifications'

export const showSpotlightNotification = () => addNotification(`Dialed-in presenters must be spotlighted manually`, 4000, 'spotlightNotification')

export default {
  showSpotlightNotification
}